import React, { useState, useEffect, useRef } from "react";
import logo from "../../../assets/images/coinlogo.png";
import "./breakmeme.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import { userGameRewards } from "../../../apis/user";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import { useAudio } from "../../../Providers/AudioProvider";
import task from "../../Task/Task";
import left from "../../../assets/images/leftarrow.svg";
import right from "../../../assets/images/rightarrow.svg";
import cancelbtn from "../../../assets/Task/cancelicon1.png";
import { FaGear } from "react-icons/fa6";
import { logPageView } from "../../../components/analytics";

const BreakoutGame = () => {
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const [ballPosition, setBallPosition] = useState({ x: 0, y: 0 });
  const [ballDirection, setBallDirection] = useState({ x: 3, y: -3 });
  const [paddlePosition, setPaddlePosition] = useState(0);
  const [blocks, setBlocks] = useState([]);
  const [score, setScore] = useState(0);
  const [gameFinished, setGameFinished] = useState(false);
  const [fallingImages, setFallingImages] = useState([]);
  const gameAreaRef = useRef(null);
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [columnImages, setColumnImages] = useState([]);
  const [gameOver, setGameOver] = useState(false);
  const [imageVisibility, setImageVisibility] = useState([]);
  const [chances, setChances] = useState(3);
  const playClick = useAudio();
  const rows = 5;
  const columns = 5;
  const imageTypes = [
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/shiba.png",
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/trump.png",
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/pepe.png",
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/bonk.png",
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/floki.png",
  ];
  const today = new Date().toDateString();
  const userId = userDetails?.userDetails?.telegramId;
  const [isPlayed, setIsPlayed] = useState(false);
  const [ballSpeed, setBallSpeed] = useState(2);
  const [showSpeedControl, setShowSpeedControl] = useState(false);

  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;

  useEffect(() => {
    const shuffledImages = [...imageTypes].sort(() => 0.5 - Math.random());
    setColumnImages(shuffledImages.slice(0, columns));
    setImageVisibility(Array(columns).fill(true));
  }, []);

  useEffect(() => {
    logPageView("breakmeme ", "Breakmeme");
  }, []);

  const generateBlocks = (gameWidth, gameHeight) => {
    const gap = 5;
    const outerPadding = 10;
    const blockWidth =
      (gameWidth - gap * (columns - 1) - outerPadding * 2) / columns;
    const blockHeight = gameHeight * 0.035 - gap;

    return Array.from({ length: rows * columns }, (_, index) => ({
      x: (index % columns) * (blockWidth + gap) + outerPadding,
      y: Math.floor(index / columns) * (blockHeight + gap) + outerPadding,
      width: blockWidth,
      height: blockHeight,
      hit: false,
      column: index % columns,
    }));
  };
  const apiCalledRef = useRef(false); // Track whether the API has been called

  const handleApiResponse = async (points, game) => {
    if (apiCalledRef.current) return; // Prevent duplicate calls

    apiCalledRef.current = true; // Set to true to prevent multiple calls

    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));

    try {
      const apiData = {
        gamePoints: points,
        gameType: "BreakOut",
        chancesToPlayed: 1,
      };
      const res = await userGameRewards(apiData);

    
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));

        setGameFinished(true);
        setGameOver(true);
        setShowResetPopup(true);

        setIsPlayed(true);
        localStorage.setItem(
          `playStatusBreaking_${userId}`,
          JSON.stringify({ isPlayed: true, date: today })
        );
      }
      else {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };
  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };
  useEffect(() => {
    const gameArea = gameAreaRef.current;
    const gameWidth = gameArea.offsetWidth;
    const gameHeight = gameArea.offsetHeight;
    setPaddlePosition((gameWidth - gameWidth * 0.2) / 2);
    setBallPosition({
      x: gameWidth / 2,
      y: gameHeight * 0.9 - 15,
    });
    setBlocks(generateBlocks(gameWidth, gameHeight));
  }, []);
  useEffect(() => {
    // Get stored data from localStorage
    const storedData = JSON.parse(
      localStorage.getItem(`playStatusBreaking_${userId}`)
    );
    const today = new Date().toDateString();

    // Check if the stored date matches today's date
    if (storedData?.date === today) {
      setIsPlayed(storedData.isPlayed);
      setGameFinished(storedData.isPlayed);
    } else {
      // Reset if the date has changed
      setIsPlayed(false);
      setGameFinished(false);
      localStorage.setItem(
        `playStatusBreaking_${userId}`,
        JSON.stringify({ isPlayed: false, date: today })
      );
    }
  }, []);
  const [gameStarted, setGameStarted] = useState(false);

  useEffect(() => {
    if (!gameStarted || gameFinished) return; // Prevent movement when game is not started

    const interval = setInterval(() => {
      updateBallPosition();
    }, 16); // Keep movement consistent

    return () => clearInterval(interval);
  }, [gameStarted, gameFinished, ballPosition]);

  const adjustBallSpeed = (newSpeed) => {
    setBallSpeed(newSpeed);
    setBallDirection((prev) => ({
      x: (prev.x / Math.abs(prev.x)) * (newSpeed * 1),
      y: (prev.y / Math.abs(prev.y)) * (newSpeed * 1),
    }));
  };

  const updateBallPosition = () => {
    const gameArea = gameAreaRef.current;
    const gameWidth = gameArea.offsetWidth;
    const gameHeight = gameArea.offsetHeight;

    let { x, y } = ballPosition;
    let { x: dx, y: dy } = ballDirection;

    if (x + dx < 0 || x + dx > gameWidth) dx = -dx;
    if (y + dy < 0) dy = -dy;

    if (
      y + dy > gameHeight * 0.9 - 5 &&
      x > paddlePosition &&
      x < paddlePosition + gameWidth * 0.2
    ) {
      dy = -Math.abs(dy);
    }

    const blockOffset = 60;
    const updatedBlocks = blocks.map((block) => {
      if (
        !block.hit &&
        x > block.x &&
        x < block.x + block.width &&
        y > block.y + blockOffset &&
        y < block.y + blockOffset + block.height
      ) {
        dy = -dy;
        return { ...block, hit: true };
      }
      return block;
    });

    setBlocks(updatedBlocks);

    const columnsHit = new Set(
      updatedBlocks.filter((block) => block.hit).map((block) => block.column)
    );

    columnsHit.forEach((column) => {
      const allColumnBlocksHit = updatedBlocks
        .filter((block) => block.column === column)
        .every((block) => block.hit);

      if (
        allColumnBlocksHit &&
        !fallingImages.some((img) => img.column === column)
      ) {
        setFallingImages((prev) => [
          ...prev,
          { column, y: 0, isFalling: true },
        ]);
        setImageVisibility((prev) => {
          const updated = [...prev];
          updated[column] = false;
          return updated;
        });
      }
    });

    if (updatedBlocks.every((block) => block.hit) && !isPlayed) {
      // setGameFinished(true);
      setScore(5000);
      handleApiResponse(5000, "finish");
    }

    if (y + dy > gameHeight) {
      if (chances > 1) {
        setChances((prev) => prev - 1); // Decrease chances
        setBallPosition({
          x: gameWidth / 2,
          y: gameHeight * 0.9 - 15,
        });
        setBallDirection({ x: 3, y: -3 });
      } else {
        if (!isPlayed) {
          // setGameOver(true); // Game Over after last chance
          setScore(1500);
          handleApiResponse(1500, "over");
          // setShowResetPopup(true); // Show the reset popup with score
        }
      }
      return;
    }

    setBallPosition({ x: x + dx, y: y + dy });
    setBallDirection({ x: dx, y: dy });
  };

  const resetGame = () => {
    const gameArea = gameAreaRef.current;
    const gameWidth = gameArea.offsetWidth;
    const gameHeight = gameArea.offsetHeight;

    setPaddlePosition((gameWidth - gameWidth * 0.2) / 2);
    setBallPosition({
      x: gameWidth / 2,
      y: gameHeight * 0.9 - 15,
    });
    setBallDirection({ x: 3, y: -3 });
    setScore(0);
    setGameFinished(false);
    setGameOver(false);
    setShowResetPopup(false);
    setFallingImages([]);
    setImageVisibility(Array(columns).fill(true));
    setBlocks(generateBlocks(gameWidth, gameHeight));
    setChances(3); // Reset chances to 3
  };

  const movePaddle = (direction) => {
    const gameArea = gameAreaRef.current;
    const gameWidth = gameArea.offsetWidth;
    const paddleWidth = gameWidth * 0.2;

    setPaddlePosition((prev) =>
      Math.min(Math.max(prev + direction * 20, 0), gameWidth - paddleWidth)
    );
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") movePaddle(-1);
      if (event.key === "ArrowRight") movePaddle(1);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    let animationFrameId;
    const updateFallingImages = () => {
      setFallingImages((prev) =>
        prev.map((img) =>
          img.isFalling && img.y < gameAreaRef.current.offsetHeight
            ? { ...img, y: img.y + 1 }
            : img
        )
      );
      animationFrameId = requestAnimationFrame(updateFallingImages);
    };

    if (fallingImages.length > 0) {
      animationFrameId = requestAnimationFrame(updateFallingImages);
    }

    return () => cancelAnimationFrame(animationFrameId);
  }, [fallingImages]);
  const startGame = () => {
    setGameStarted(true); // Start game
    setGameFinished(false);
    setGameOver(false);
    setScore(0);
    setChances(3); // Reset chances
  };

  return (
    <>
      <img
        onClick={() => {
          toogleMenu(task, "task");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      <div className="task-page" style={{ width: "100%" }}>
        <div className="row displayflex">
          <div>
            <h2 className="welcometextmeme" style={{ marginBottom: "5px" }}>
              Breakout MEME
            </h2>
          </div>

          {gameStarted && !isPlayed && (
            <div className="chances-counter text-center">
              <p
                style={{
                  fontSize: "13px",
                  marginBottom: "0px",
                  textTransform: "uppercase",
                }}
                className="text-light"
              >
                Chances Remaining: {chances}
              </p>
            </div>
          )}
          {/* {!isPlayed && (
 <>
 <div className="row flex">
 <div className="col-4">
 <button onClick={startGame} disabled={gameStarted}>
 Start Game
 </button>
 </div>
 </div>
 </>
 )} */}

          <div className="col-9">
            <div
              ref={gameAreaRef}
              className="game-area"
              style={{
                position: "relative",
                height: "50vh",
                backgroundColor: "#333",
                // margin: "10px auto",
                overflow: "hidden",
              }}
            >
              {!isPlayed && !gameStarted ? (
                <div className="row flex startgame">
                  <div className="col-9">
                    <p className="brick-head">
                      Break the Brick!
                      <br /> 3 chances to free the memes!
                    </p>
                    <button
                      className="control-btnbreakmeme"
                      onClick={startGame}
                      disabled={gameStarted}
                    >
                      Start Game
                    </button>
                  </div>
                </div>
              ) : isPlayed && score == 0 ? (
                <div className="row flex startgame">
                  <div className="col-10">
                    <h4 className="control-btnbreakmeme1" style={{color:"#fff",textTransform:"uppercase"}}>
                      Come Back Tomorrow
                    </h4>
                  </div>
                </div>
              ) : (
                ""
              )}
              {columnImages.map(
                (image, colIndex) =>
                  imageVisibility[colIndex] && (
                    <div
                      key={colIndex}
                      style={{
                        position: "absolute",
                        top: "5%",
                        left: `${
                          colIndex * (100 / columns) +
                          (100 / columns -
                            (45 / gameAreaRef.current?.offsetWidth) * 100) /
                            2
                        }%`,
                        width: "45px",
                        height: "45px",
                        backgroundImage: `url(${image})`,
                        backgroundSize: "cover",
                      }}
                    ></div>
                  )
              )}

              {fallingImages.map((img, index) => {
                const gameWidth = gameAreaRef.current?.offsetWidth || 0;
                const gap = 5;
                const outerPadding = 10;
                const blockWidth =
                  (gameWidth - gap * (columns - 1) - outerPadding * 2) /
                  columns;

                // Calculate the exact center of the block column
                const blockCenterX =
                  img.column * (blockWidth + gap) +
                  outerPadding +
                  blockWidth / 2;
                // Adjust for image width to center it precisely
                const xPosition = blockCenterX - 22.5; // Half of 45px

                return (
                  <div
                    key={index}
                    style={{
                      position: "absolute",
                      top: `${img.y}%`,
                      left: `${xPosition}px`,
                      width: "45px",
                      height: "45px",
                      backgroundImage: `url(${columnImages[img.column]})`,
                      backgroundSize: "cover",
                    }}
                  ></div>
                );
              })}

              {blocks.map(
                (block, index) =>
                  !block.hit && (
                    <div
                      key={index}
                      className="block"
                      style={{
                        position: "absolute",
                        left: block.x,
                        top: block.y + 60,
                        width: block.width,
                        height: block.height,
                        backgroundColor: "#09BD1B",
                      }}
                    ></div>
                  )
              )}

              <div
                className="ball"
                style={{
                  position: "absolute",
                  left: ballPosition.x,
                  top: ballPosition.y,
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#FC373A",
                }}
              ></div>

              <div
                className="paddle"
                style={{
                  position: "absolute",
                  bottom: "5%",
                  left: paddlePosition,
                  width: "25%",
                  height: "5px",
                  backgroundColor: "#fff",
                }}
              ></div>
              {/* {isPlayed ? (
 <div
 style={{
 position: "absolute",
 top: "50%",
 left: "50%",
 transform: "translate(-50%, -50%)",
 color: "#fff",
 textAlign: "center",
 }}
 >
 <h2>You Win! Come back tomorrow</h2>
 </div>
 ) : null} */}

              {(gameFinished || gameOver) &&
              isPlayed &&
              score > 0 &&
              !IsPointsReached ? (
                <div className="overlay">
                  <div className="popup">
                    <div className="popup-content">
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                        className="cancel-img"
                        onClick={resetGame}
                      />
                      <h2 className="epic">Game Over!</h2>
                      <div className="row text-center">
                        <div className="col-12">
                          <div className="epic-div">
                            <p className="pointsLabel">TOKENS EARNED</p>
                            <div className="pointsValue1">
                              <img src={logo} alt="logo" />
                              <p className="pointsNumber">{score}</p>
                            </div>
                          </div>
                          <p className="bottom-text">
                            Play daily to boost your score and rack up more
                            Tokens!
                          </p>
                        </div>
                      </div>
                    </div>
                    <button className="playgame" onClick={resetGame}>
                      DONE
                    </button>
                  </div>
                </div>
              ) : (gameFinished || gameOver) &&
                isPlayed &&
                score > 0 &&
                IsPointsReached ? (
                <div className="overlay">
                  <div className="popup">
                    <div className="popup-content">
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                        className="cancel-img"
                        onClick={resetGame}
                      />
                      <h2 className="epic">Game Over!</h2>
                      <div className="row text-center">
                        <div className="col-12">
                          <div className="epic-div">
                            <p className="pointsLabel">NO TOKENS EARNED</p>
                          </div>
                          <p className="bottom-text">
                            You've completed this day's play. Please return
                            tomorrow to continue!
                          </p>
                        </div>
                      </div>
                    </div>
                    <button className="playgame" onClick={resetGame}>
                      DONE
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {!isPlayed && (
            <div
              className="controls"
              style={{ textAlign: "center", marginTop: "0px" }}
            >
              <button
                className="control-btnbreakmeme displayflex"
                onClick={() => movePaddle(-1)}
              >
                <img src={left} />
                &nbsp;Left
              </button>
              <button
                className="control-btnbreakmeme displayflex"
                onClick={() => movePaddle(1)}
              >
                Right&nbsp;
                <img src={right} />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default BreakoutGame;